/**
 * HUD – heads-up display overlay.
 */
export class HUD {
  constructor() {
    this.hud = document.getElementById('hud');
    this.p1Health = document.getElementById('p1-health');
    this.p2Health = document.getElementById('p2-health');
    this.p1Name = document.getElementById('p1-name');
    this.p2Name = document.getElementById('p2-name');
    this.roundDisplay = document.getElementById('round-display');
    this.centerMessage = document.getElementById('center-message');
    this.controlsHelp = document.getElementById('controls-help');
    this.p1Weapons = document.getElementById('p1-weapons');
    this.p2Weapons = document.getElementById('p2-weapons');
    this.camIndicator = document.getElementById('cam-indicator');
    this.zoneWarning = document.getElementById('zone-warning');
    this.zoneInfo = document.getElementById('zone-info');
  }

  show() { this.hud.classList.add('active'); }
  hide() { this.hud.classList.remove('active'); }

  updateHealth(p1Hp, p2Hp, maxHp) {
    this.p1Health.style.width = `${(p1Hp / maxHp) * 100}%`;
    this.p2Health.style.width = `${(p2Hp / maxHp) * 100}%`;

    this.p1Health.style.background = p1Hp / maxHp < 0.3
      ? 'linear-gradient(90deg,#ff4444,#ff6666)'
      : 'linear-gradient(90deg,#2196F3,#64B5F6)';
    this.p2Health.style.background = p2Hp / maxHp < 0.3
      ? 'linear-gradient(90deg,#ff4444,#ff6666)'
      : 'linear-gradient(90deg,#F44336,#EF5350)';
  }

  updateWeapons(playerId, currentWeapon, cooldowns) {
    const container = playerId === 0 ? this.p1Weapons : this.p2Weapons;
    if (!container) return;
    const slots = container.querySelectorAll('.weapon-slot');
    slots.forEach(slot => {
      const w = slot.dataset.weapon;
      slot.classList.toggle('active', w === currentWeapon);
      const onCd = (w === 'rock' && cooldowns.rock > 0) ||
                   (w === 'scissors' && cooldowns.scissors > 0) ||
                   (w === 'paper' && cooldowns.paper > 0);
      slot.classList.toggle('cooldown', onCd);
    });
  }

  updateRoundDisplay(p1Wins, p2Wins, roundsToWin) {
    let html = '<span style="color:#64B5F6">P1</span> ';
    for (let i = 0; i < roundsToWin; i++)
      html += `<span class="round-dot ${i < p1Wins ? 'won-p1' : ''}"></span>`;
    html += ' ⚔️ ';
    for (let i = 0; i < roundsToWin; i++)
      html += `<span class="round-dot ${i < p2Wins ? 'won-p2' : ''}"></span>`;
    html += ' <span style="color:#EF5350">P2</span>';
    this.roundDisplay.innerHTML = html;
  }

  showMessage(text, duration = 2000, color = '#fff') {
    this.centerMessage.textContent = text;
    this.centerMessage.style.color = color;
    this.centerMessage.classList.add('show');
    if (this._msgTimeout) clearTimeout(this._msgTimeout);
    if (duration > 0) {
      this._msgTimeout = setTimeout(() => {
        this.centerMessage.classList.remove('show');
      }, duration);
    }
  }

  hideMessage() { this.centerMessage.classList.remove('show'); }

  setControlsHelp(text) { this.controlsHelp.textContent = text; }
  setNames(p1, p2) { this.p1Name.textContent = p1; this.p2Name.textContent = p2; }

  showCamIndicator(mode) {
    if (this.camIndicator) {
      this.camIndicator.textContent = mode === 'fps' ? '👁️ FPS  (F / G to switch)' : '🎥 TPS  (F / G to switch)';
      this.camIndicator.style.display = 'block';
    }
  }
  hideCamIndicator() {
    if (this.camIndicator) this.camIndicator.style.display = 'none';
  }

  // ── Zone ──
  showZoneWarning() {
    if (this.zoneWarning) {
      this.zoneWarning.classList.add('show');
      setTimeout(() => this.zoneWarning.classList.remove('show'), 4000);
    }
  }
  hideZoneWarning() {
    if (this.zoneWarning) this.zoneWarning.classList.remove('show');
  }

  updateZoneTimer(elapsed, startDelay, currentRadius, minRadius) {
    if (!this.zoneInfo) return;
    const timeUntilShrink = Math.max(0, startDelay - elapsed);
    if (timeUntilShrink > 0) {
      this.zoneInfo.textContent = `Zone closes in ${Math.ceil(timeUntilShrink)}s`;
      this.zoneInfo.style.color = timeUntilShrink < 5 ? '#ff4444' : '#aaa';
    } else {
      const pct = Math.round(((currentRadius - minRadius) / (38 - minRadius)) * 100);
      this.zoneInfo.textContent = `Zone: ${Math.max(0, pct)}%`;
      this.zoneInfo.style.color = '#ff6644';
    }
  }
}
